import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { DefaultContentContainer } from "app/UtilitiesAndConstants/UtilitiesComponents/FadeWrapper";

const { carbon } = colorsPalettes;
const SUGGESTIONS_HEIGHT_OVERFLOW = "479px";

export const InputAndImportWrapper = styled.div`
    display: flex;
`;

export const WebsitesWrapper = styled(FlexColumn)`
    height: 100%;
`;

export const RecomendationsContainer = styled(FlexColumn)`
    padding: 16px 20px;
    margin-top: 24px;
    border: 1px solid ${carbon[50]};
    border-radius: 4px;
    position: relative;
    flex: 1 1 auto;
`;

export const RecomendationsTitle = styled.div`
    ${setFontVariant("subtitle1", carbon[300])};
    display: flex;
    gap: 8px;
    margin-bottom: 26px;
`;

export const RecomendationsListContainer = styled.div`
    /* prevent height overflow when list is long */
    max-height: calc(100vh - ${SUGGESTIONS_HEIGHT_OVERFLOW});
`;

export const StyledFadeWrapper = styled(DefaultContentContainer)`
    /* prevent height overflow when list is long */
    max-height: ${`calc(100vh - ${SUGGESTIONS_HEIGHT_OVERFLOW})`};
`;
